import {
  adaptStoreToFilterPath,
  adaptStoreToPageURL,
} from 'src/adapters/storeToPageURL/adaptStoreToPageURL';
import { buildListingsURL } from 'src/adapters/storeToPageURL/buildListingsURL';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import type { Facet } from 'src/redux/productsQuery/types/Facet';
import { selectListingsBasePath } from './selectListingsBasePath';

export const buildTaxonomyListingURL = (state: ReduxApplicationState): string => {
  const basePath = selectListingsBasePath(state);
  const filterPath = adaptStoreToFilterPath(state);
  const params = adaptStoreToPageURL(state, state.productsQuery.page);
  return buildListingsURL(basePath, filterPath, params, state.navigation.hash);
};

export const buildTaxonomyFacetHref = (state: ReduxApplicationState, nextFacets: Facet[]): string =>
  buildTaxonomyListingURL({
    ...state,
    productsQuery: {
      ...state.productsQuery,
      facets: nextFacets,
      page: 1,
    },
  });
